<!--
# -----------------------------------------------------------------------------
# Component: PolicyHeader.vue
# Author: PST
# Created Date: 02/April/2019
# Comments: Policy Header main page
# -----------------------------------------------------------------------------
-->
<template>
  <div>
    <v-layout row wrap>
      <v-tabs v-model="polTabs" icons-and-text>
        <v-tab @click.native="doTab(0)">Main<v-icon color="cyan">mdi-image-album</v-icon></v-tab>
        <v-tab @click.native="doTab(1)">Insured<v-icon color="cyan">mdi-account-check</v-icon></v-tab>
        <v-tab @click.native="doTab(2)">Other Details<v-icon color="cyan">mdi-playlist-plus</v-icon></v-tab>
        <v-tab @click.native="doTab(3)" v-if="renInfoApp && polMaster.renCnt > 0">Renewal Information<v-icon color="cyan">mdi-refresh</v-icon></v-tab>
      </v-tabs>
      <v-card>
          <v-layout row wrap>
            <v-flex xs12>
              <router-view ref="childComponent"></router-view>
            </v-flex>
          </v-layout>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { POLICY_HEADER_TAB } from '@/store/types'
export default {
  data() {
    return {
      headers: 0,
      polTabs: 0,
      proceedForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        mode: undefined
      },
      renInfoApp: false
    }
  },
  methods: {
    doInit() {
      this.headers = this.policyHeaderTab
      this.polTabs = this.policyHeaderTab
      this.getRenInfoApp()
    },
    // AR: Added OS-311 14-Aug-2020
    // Prevent from jumping to Other Details tab if Insured Ref No is missing
    async doValidateTab(tabIndex) {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.validateTab
      if (apiUrl) {
        this.proceedForm.polNo = this.polMaster.polNo
        this.proceedForm.renCnt = this.polMaster.renCnt
        this.proceedForm.endtCnt = this.polMaster.endtCnt
        this.proceedForm.mode = tabIndex
        try {
          const result = await this.$http.post(apiUrl, this.proceedForm)
          if (result.data) {
            return true
          } else {
            return false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
            return false
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    doTab(index) {
      if (this.headers !== 3) {
        this.resetMessages()
        this.$refs.childComponent.doValidateAllWarn().then(result2 => {
          if (result2) {
            this.$refs.childComponent.$validator.validateAll().then(result => {
              if (result) {
                this.$refs.childComponent.policy.saving = true
                if (this.headers === 0) {
                  this.$store.dispatch('policyMain', this.$refs.childComponent.mainForm)
                } else if (this.headers === 1) {
                  this.$store.dispatch('policyInsured', this.$refs.childComponent.mainForm)
                } else if (this.headers === 2) {
                  this.$store.dispatch('policyOtherDetails', this.$refs.childComponent.mainForm)
                }

                this.$refs.childComponent.doPolMasterSave().then(success => {
                  if (success) {
                    if (this.policyHeaderTab === 2) {
                      this.$refs.childComponent.doProceedOtherDetails().then(success2 => {
                        if (success2) {
                          this.$refs.childComponent.policy.saving = false
                          this.headers = index
                          this.changeTab(this.policyHeaderTab)
                        } else {
                          this.$refs.childComponent.policy.saving = false
                          this.$toast.error('An unexpected error occured while saving policy record.')
                          this.polTabs = this.headers
                        }
                      })
                    } else {
                      this.$refs.childComponent.policy.saving = false
                      this.headers = index
                      this.changeTab(this.policyHeaderTab)
                    }
                  } else {
                    this.$toast.error('An unexpected error occured while saving policy record.')
                    this.$refs.childComponent.policy.saving = false
                    this.polTabs = this.headers
                  }
                })
              } else {
                this.promptFieldCheck()
                this.polTabs = this.headers
              }
            })
          }
        })
      } else {
        // From PolRenewalInfo
        this.$refs.childComponent.loading = true
        this.headers = index
        this.changeTab(this.policyHeaderTab)
      }
    },
    changeTab(prevIndex) {
      if (this.headers === 0) {
        this.$store.commit(POLICY_HEADER_TAB, 0)
        this.$router.push({ name: 'policyHeader' })
      } else if (this.headers === 1) {
        if (prevIndex === 0) {
          this.$refs.childComponent.valPolStatsVal().then(successVal => {
            if (successVal) {
              this.$store.commit(POLICY_HEADER_TAB, 1)
              this.$router.push({ name: 'policyInsured' })
            } else {
              this.headers = prevIndex
              this.polTabs = prevIndex
            }
          })
        } else {
          this.$store.commit(POLICY_HEADER_TAB, 1)
          this.$router.push({ name: 'policyInsured' })
        }
      } else if (this.headers === 2) {
        this.doValidateTab(this.headers).then(successTab => {
          if (successTab) {
            this.$store.commit(POLICY_HEADER_TAB, 2)
            this.$router.push({ name: 'policyOtherDetails' })
          } else {
            this.headers = prevIndex
            this.polTabs = prevIndex
            this.$toast.error('Insured Reference is required.')
          }
        })
      } else if (this.headers === 3) {
        this.$store.commit(POLICY_HEADER_TAB, 3)
        this.$router.push({ name: 'policyRenewalInfo' })
      }
    },
    async getRenInfoApp() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.renInfoApp
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          this.renInfoApp = data
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      }
    }
  },
  computed: {
    initStatus() {
      return this.$store.state.underwriting.policyHeaderSettings.init
    },
    policyHeaderTab: {
      set(val) {
      },
      get() {
        return this.$store.state.underwriting.policy.policyHeaderTab
      }
    },
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    }
  },
  watch: {
    'policyHeaderTab': function (value) {
      this.headers = value
      this.polTabs = this.policyHeaderTab
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.policyHeaderSettings.init !== 1) {
      this.$store.dispatch('policyHeaderInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">
@import "../../../../assets/scss/underwriting.scss";
</style>
